import WHowFirst from './WHowFirst'

export default WHowFirst
